import { NoResults, SpinnerIndicators } from '@clearkit/icons';
import {
  CKDrawer,
  CKLayoutHorizontal,
  CKLayoutVertical,
  CKSearch,
  CKSelectableItem,
  CKSelectPill,
} from 'clearkit';
import { useState } from 'react';

import { LogDetailsDrawer } from './LogDetailsDrawer';
import { LogsList } from './LogsList';
import { LogAPIType, LogListItem, RequestType, ResponseStatus } from './types';
import { useLogs } from './useLogs';
import { itemsAPI, itemsLog, itemsResponse } from './utils';

export const LogsPage = () => {
  const [activeLog, setActiveLog] = useState<LogListItem | null>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isLoading, _setIsLoading] = useState(false);
  const [filterAPI, setFilterAPI] = useState<CKSelectableItem>(itemsAPI[0]);
  const [filterType, setFilterType] = useState<CKSelectableItem>(itemsLog[0]);
  const [filterResponse, setFilterResponse] = useState<CKSelectableItem>(
    itemsResponse[0],
  );
  const [search, setSearch] = useState('');

  const { logs } = useLogs({
    api: filterAPI?.value as LogAPIType,
    type: filterType?.value as RequestType,
    status: filterResponse?.value as ResponseStatus,
    query: search,
  });

  const handleFilterAPI = (newValue: CKSelectableItem) => {
    setFilterAPI(newValue);
  };

  const handleFilterLog = (newValue: CKSelectableItem) => {
    setFilterType(newValue);
  };

  const handleFilterResponse = (newValue: CKSelectableItem) => {
    setFilterResponse(newValue);
  };

  const handleSearch = (value: string) => {
    setSearch(value);
  };

  const handleActiveLog = (log: LogListItem) => {
    setActiveLog(log);
    setIsDrawerOpen(true);
  };

  return (
    <div className="h-full space-y-8">
      <CKLayoutHorizontal
        as="header"
        className="sticky top-0 p-6 pb-4 bg-white border-b border-gray-200"
      >
        <CKLayoutHorizontal justifyContent="start">
          <CKSelectPill
            items={itemsAPI}
            onChange={handleFilterAPI}
            placeholder="Filter by API"
            value={filterAPI}
          />
          <CKSelectPill
            items={itemsLog}
            onChange={handleFilterLog}
            placeholder="Filter by log"
            value={filterType}
          />
          <CKSelectPill
            items={itemsResponse}
            onChange={handleFilterResponse}
            placeholder="Filter by response"
            value={filterResponse}
          />
        </CKLayoutHorizontal>
        <CKSearch
          className="grow shrink max-w-[20rem]"
          onChange={handleSearch}
          placeholder="Filter by path"
          value={search}
        />
      </CKLayoutHorizontal>
      {isLoading ? (
        <CKLayoutHorizontal
          className="w-full h-full py-16"
          justifyContent="center"
        >
          <SpinnerIndicators className="w-10 h-10" />
        </CKLayoutHorizontal>
      ) : logs ? (
        <LogsList logs={logs} onClick={handleActiveLog} />
      ) : (
        <CKLayoutVertical
          alignItems="center"
          className="p-12 text-[1.5rem] gap-4"
        >
          <NoResults className="w-10 h-10 text-gray-500" />
          <div>No Logs Found</div>
        </CKLayoutVertical>
      )}

      <CKDrawer
        hasBlurredBackdrop={false}
        isVisible={isDrawerOpen}
        onToggle={() => setIsDrawerOpen(false)}
      >
        <LogDetailsDrawer log={activeLog} />
      </CKDrawer>
    </div>
  );
};
